/* Seller Home/Listings Features */
export const sellerHomeInit = () => {
    /* Hide purchase grid items for variants that are already part of active/pending/sold listings */
    if (typeof recListingVariants !== "undefined") {
      let purchaseVariants: { [key: string]: number } = {};
      document
        .querySelectorAll(".rec-grid-item-purchase")
        .forEach((thisPurchase) => {
          const thisVariant = thisPurchase.getAttribute("data-rec-order-variant");
          const thisCTA = thisPurchase.querySelector(
            ".rec-resell-cta",
          ) as HTMLElement;
  
          if (thisVariant !== null) {
            if (!(thisVariant in purchaseVariants)) {
              purchaseVariants[thisVariant] = 0;
            }
            purchaseVariants[thisVariant]++;
            if (
              thisVariant in recListingVariants &&
              purchaseVariants[thisVariant] > recListingVariants[thisVariant]
            ) {
              thisCTA.classList.add("rec-disabled");
              thisCTA.classList.add("rec-in-progress");
              thisCTA.setAttribute("href", "javascript:;");
            }
          }
        });
    }
  };
  
  /* Seller Settings Features */
  export const sellerSettingsInit = () => {
    const stripeSettingsElem = document.getElementById("rec-settings-stripe");
    const sellerStripeManageLink = async () => {
      if (recAppProxyConfig.customer.stripe.aid.length > 0) {
        const stripeLinkResponse = await fetch(
          recAppProxyConfig.paths.pathStripeDashboardGet.replace(
            "%aid%",
            recAppProxyConfig.customer.stripe.aid,
          ) +
          "&return_to=" +
          encodeURIComponent(recAppProxyConfig.settings.shop.app_proxy_url ?? ""),
          {
            method: "GET",
            headers: { "Content-Type": "application/json" },
          },
        );
        const stripeLinkResult = await stripeLinkResponse.json();
        if (stripeSettingsElem && !stripeLinkResult.errors) {
          const stripeDashboardLinkElem = document.getElementById(
            "rec-settings-stripe-dashboard-link",
          ) as HTMLAnchorElement | null;
          if (stripeDashboardLinkElem) {
            stripeDashboardLinkElem.href = stripeLinkResult.data.url;
            stripeSettingsElem.classList.add("enabled");
            if (stripeLinkResult.data.onboarded) {
              stripeSettingsElem.classList.add("onboarded");
              stripeDashboardLinkElem.innerHTML =
                stripeDashboardLinkElem.getAttribute("data-text-onboarded") || "";
            } else {
              stripeDashboardLinkElem.innerHTML =
                stripeDashboardLinkElem.getAttribute("data-text-pending") || "";
            }
          }
        } else if (stripeSettingsElem) {
          stripeSettingsElem.classList.add("error");
        }
      }
    };
  
    if (stripeSettingsElem) {
      sellerStripeManageLink();
    }
  };